import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "wasz_locale";

const dictionary = {
  nl: {
    nav: {
      home: "Home",
      services: "Diensten",
      mobile_truckwash: "Mobiele Truckwash",
      truck_cleaning: "Vrachtwagenreiniging",
      fleet_cleaning: "Fleet Cleaning",
      wagenpark: "Wagenpark Reiniging",
      waszbase: "WaszBase",
      haccp: "HACCP & Certificaten",
      locations: "Locaties",
      almere: "Truckwash Almere",
      amsterdam: "Truckwash Amsterdam",
      denhaag: "Truckwash Den Haag",
      rotterdam: "Truckwash Rotterdam",
      utrecht: "Truckwash Utrecht",
      about: "Over Ons",
      contact: "Contact",
      faq: "FAQ",
      blog: "Kennisbank",
      cta: "Offerte aanvragen",
      demo: "Demo WaszBase",
    },
    hero: {
      overline: "Mobiele truckwash · Fleet cleaning · WaszBase portaal",
      title_a: "Professionele Mobiele Truckwash &",
      title_b: "Digitale Wagenparkadministratie",
      subtitle: "Wasz.nl reinigt vrachtwagens, trailers en bedrijfsvoertuigen op uw locatie — gekoppeld aan WaszBase voor certificaten, NVWA-dossiers en factuurbeheer per kenteken.",
      cta_primary: "Offerte aanvragen",
      cta_secondary: "Direct contact",
      cta_demo: "Gratis demo WaszBase",
      stats_a: "Trucks per maand",
      stats_b: "Landelijke dekking",
      stats_c: "HACCP-conform",
      stats_d: "Servicebeschikbaarheid",
    },
    common: {
      learn_more: "Meer informatie",
      contact_us: "Neem contact op",
      request_quote: "Offerte aanvragen",
      view_all: "Bekijk alles",
      read_article: "Lees artikel",
      back: "Terug",
      submit: "Verstuur",
      send: "Verzenden",
      sending: "Bezig met verzenden…",
      success: "Bedankt — we nemen binnen 1 werkdag contact op.",
      error: "Er ging iets mis. Probeer opnieuw of bel ons direct.",
      required: "Verplicht veld",
      page_of: "Pagina",
    },
    form: {
      name: "Naam",
      email: "E-mail",
      phone: "Telefoonnummer",
      company: "Bedrijfsnaam",
      fleet_size: "Wagenpark grootte",
      message: "Bericht",
      location: "Locatie / plaats",
      location_placeholder: "Bijv. Amsterdam",
      source: "Hoe heeft u ons gevonden?",
      source_placeholder: "Maak een keuze",
      source_other_label: "Vul a.u.b. toe hoe u ons heeft gevonden",
      source_other_placeholder: "Bijv. via een collega",
      source_options: {
        google: "Google",
        chatgpt: "ChatGPT",
        linkedin: "LinkedIn",
        facebook: "Facebook",
        transport: "Via transportbedrijf",
        other: "Anders",
      },
      type_label: "Type aanvraag",
      type_quote: "Offerte",
      type_demo: "WaszBase demo",
      type_contact: "Algemene vraag",
    },
    footer: {
      tagline: "Mobiele truckwash & digitale wagenparkadministratie voor heel Nederland.",
      services: "Diensten",
      locations: "Locaties",
      company: "Bedrijf",
      legal: "Juridisch",
      privacy: "Privacy",
      terms: "Algemene voorwaarden",
      copyright: "Wasz.nl — Alle rechten voorbehouden.",
      certified: "HACCP-werkwijze · NVWA-documentatie",
      postal_label: "Postadres",
      mobile_note: "Wij werken volledig mobiel — op uw locatie.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      mobile_truckwash: "Mobile Truckwash",
      truck_cleaning: "Truck Cleaning",
      fleet_cleaning: "Fleet Cleaning",
      wagenpark: "Fleet Maintenance",
      waszbase: "WaszBase",
      haccp: "HACCP & Certificates",
      locations: "Locations",
      almere: "Truckwash Almere",
      amsterdam: "Truckwash Amsterdam",
      denhaag: "Truckwash Den Haag",
      rotterdam: "Truckwash Rotterdam",
      utrecht: "Truckwash Utrecht",
      about: "About",
      contact: "Contact",
      faq: "FAQ",
      blog: "Knowledge Base",
      cta: "Request a Quote",
      demo: "WaszBase Demo",
    },
    hero: {
      overline: "Mobile truckwash · Fleet cleaning · WaszBase portal",
      title_a: "Professional Mobile Truckwash &",
      title_b: "Digital Fleet Administration",
      subtitle: "Wasz.nl cleans trucks, trailers and commercial vehicles at your site — connected to WaszBase for certificates, NVWA dossiers and invoice management per license plate.",
      cta_primary: "Request a quote",
      cta_secondary: "Direct contact",
      cta_demo: "Free WaszBase demo",
      stats_a: "Trucks per month",
      stats_b: "Nationwide coverage",
      stats_c: "HACCP compliant",
      stats_d: "Service availability",
    },
    common: {
      learn_more: "Learn more",
      contact_us: "Contact us",
      request_quote: "Request a quote",
      view_all: "View all",
      read_article: "Read article",
      back: "Back",
      submit: "Submit",
      send: "Send",
      sending: "Sending…",
      success: "Thanks — we'll be in touch within one business day.",
      error: "Something went wrong. Please try again or call us directly.",
      required: "Required field",
      page_of: "Page",
    },
    form: {
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      fleet_size: "Fleet size",
      message: "Message",
      location: "Location / city",
      location_placeholder: "E.g. Amsterdam",
      source: "How did you find us?",
      source_placeholder: "Select an option",
      source_other_label: "Please specify how you found us",
      source_other_placeholder: "E.g. through a colleague",
      source_options: {
        google: "Google",
        chatgpt: "ChatGPT",
        linkedin: "LinkedIn",
        facebook: "Facebook",
        transport: "Via transport company",
        other: "Other",
      },
      type_label: "Request type",
      type_quote: "Quote",
      type_demo: "WaszBase demo",
      type_contact: "General question",
    },
    footer: {
      tagline: "Mobile truckwash & digital fleet administration across the Netherlands.",
      services: "Services",
      locations: "Locations",
      company: "Company",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
      copyright: "Wasz.nl — All rights reserved.",
      certified: "HACCP working method · NVWA documentation",
      postal_label: "Postal address",
      mobile_note: "We operate fully mobile — at your location.",
    },
  },
};

const LangContext = createContext({ lang: "nl", t: (k) => k, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "nl";
    return localStorage.getItem(STORAGE_KEY) || "nl";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const setLang = useCallback((next) => setLangState(next), []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = dictionary[lang] || dictionary.nl;
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return path;
      }
      return typeof node === "string" ? node : path;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
